import React, { useState, useRef, useEffect } from "react";
import LiveSessionCard from "../components/LiveSessionCard";
import { useApi } from "../../../service/ApiContext";
import Loader, { LocalStorage } from "../../../utils/Utils";
import "../styles/LiveSessionCard.css";
import LiveTabNavigator from "../components/LiveSessionTab";
import { registerResponse } from "../data/response/RegisterResponse";
import ResgisterApiClient from "../data/apiClient/RegisterClient";
import Logger from "../../../utils/Logger";
import noSession from "../../../assets/images/LiveSession/noSessionImage.svg";
import SuccessSnackPopUp from "../../../components/SuccessSnackPopup";
import jozunalayered from "../../../assets/images/LiveSession/jozunaLayeredLogo.png";
import CommonUtils from "../../../utils/Common_Utils";
import LiveBg from "../../../assets/images/LiveSession/live_bg.png";
import { useDispatch, useSelector } from "react-redux";
import needHelpIcon from "../../../assets/images/LiveSession/needHelpIcon.svg";
import LiveSessionNeedHelp from "../components/LiveSessionNeedHelp";
import { RootState } from "../../../store/store";
interface LiveSession {
  session_url: string | null;
  session_password: string | null;
  registered: boolean;
}

interface LiveSessionData {
  event_id: string;
  program_id: string;
  program_title: string;
  event_type: string;
  event_title: string;
  event_description: string | null;
  event_duration: string;
  start_date: string;
  end_date: string;
  start_time: string;
  end_time: string;
  live_session: LiveSession;
  registration_deadline?: string | null;
  prerequisites?: string | null;
  learning_outcomes?: string | null;
}
const LiveSessionPageVersionTwo: React.FC = () => {
  const [sessions, setSessions] = useState<LiveSessionData[]>([]);
  const api = useApi();
  const [status, setStatus] = useState<string>("Active");

  const [liveActiveTab, setLiveActiveTab] = useState(0);
  const [selectedProgramId, setSelectedProgramId] = useState<string>("");
  const [showNotification, setShowNotification] = useState<string | null>(null);

  const handleLiveTabChange = (index: number) => {
    setLiveActiveTab(index);
  };

  const handleShowNotification = (msg: string) => {
    setShowNotification(msg);
  };

  const handleCloseNotification = () => {
    setShowNotification(null);
  };
  const listProgramData = useSelector(
    (state: RootState) => state.programs.programs,
  );
  const dispatch = useDispatch();
  const fetchLiveSessions = async () => {
    if (listProgramData.length === 0) return;
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    Loader.showLoading();
    try {
      const programQuery = selectedProgramId ? selectedProgramId : "all";
      let statusQuery = "";

      if (liveActiveTab === 0) {
        statusQuery = "Active";
        setStatus("Active");
      } else if (liveActiveTab === 1) {
        statusQuery = "Upcoming";
        setStatus("Upcoming");
      } else if (liveActiveTab === 2) {
        statusQuery = "Closed";
        setStatus("Closed");
      }

      // const response = await api.get<{ live_session: LiveSessionData[] }>(`/live_sessions/${status}`);
      const response = await api.get<{ live_session: LiveSessionData[] }>(
        `/live_session/${statusQuery}?program_ids=${programQuery}&offset_time=${
          CommonUtils.findOffsetDuration().offset
        }`, // Include program ID in API call
      );
      Logger.info("API Response:", response.data);
      if (response.data && Array.isArray(response.data.live_session)) {
        const sessionsData = response.data.live_session;
        setSessions(response.data.live_session);
        // // Find the first session where session_url is not null AND registered is true
        // const activeSession = sessionsData.find(
        //   (session) =>
        //     session.live_session?.session_url &&
        //     session.live_session.registered === true
        // );

        // // Set the session URL if found, otherwise clear it
        // if (activeSession && activeSession.live_session.session_url) {
        //   dispatch(
        //     setLiveSessionActiveUrl(activeSession.live_session.session_url)
        //   );
        //   Logger.info(
        //     "Found active session URL:",
        //     activeSession.live_session.session_url
        //   );
        // } else {
        //   dispatch(setLiveSessionActiveUrl(null));
        //   Logger.info("No active session found with URL and registration");
        // }
      } else {
        Logger.error("Expected an array but got:", typeof response.data);
        setSessions([]);
      }
    } catch (error) {
      Logger.error("Error fetching live sessions:", error);
      setSessions([]);
    } finally {
      Loader.dismissLoading();
    }
  };

  const registerApi = async (eventId: string, programId: string) => {
    Loader.showLoading("Loading...");
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    try {
      await api
        .post<registerResponse>(
          `${ResgisterApiClient.register}${eventId}?program_id=${programId}`,
        )
        .then((res) => {
          if (res?.data?.error === null) {
            handleShowNotification(res.data.detail);
            fetchLiveSessions();
          }
        })
        .catch((error) => {
          Logger.info("error response", error);
        });
    } catch (error) {
      Logger.info("error response", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  const [isModalOpen, setModalOpen] = useState(false);

  const needHelptoggleModal = () => {
    setModalOpen(!isModalOpen);
    if (!isModalOpen) {
      // logActionEvent(
      //   analytics_strings.analytics_events.dashboard_skill_needHelp,
      //   {
      //     candidate_id: userData.candidate_id,
      //   },
      // );
    }
  };

  useEffect(() => {
    fetchLiveSessions();
  }, [liveActiveTab, selectedProgramId]);
  const handleRefreshClick = () => {
    fetchLiveSessions();
  };

  return (
    <div>
      <div className="desktop-ui_assessmentCheck">
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "start",
              justifyContent: "space-between",
              boxShadow: "0 4px 8px rgba(105, 103, 103, 0.1)", // Bottom box shadow
              padding: "20px",
              // paddingRight: "0px",
              // paddingLeft: "0px",
              height: "12vh",
              zIndex: 10000,
              marginBottom: "10px",
            }}
            className="v2-liveSessionHeader"
          >
            <div className="v2-liveSessionHeaderLeft">
              <div className="v2-liveSessionTitleText">Live Sessions</div>
              <div className="v2-liveSessionHeaderSubText">
                Hello Learner, stay connected with your upcoming live sessions
              </div>
            </div>
            <div className="v2-liveSessionHeaderRight">
              <img
                src={needHelpIcon}
                alt=""
                style={{ height: "35px", width: "35px", cursor: "pointer" }}
                onClick={needHelptoggleModal}
              />
            </div>
          </div>
          {/* <hr className="v2-livesessionDivider" /> */}

          <div className="live-session-page">
            {/* Sticky Tab */}
            <div className="sticky-tab">
              <LiveTabNavigator
                activeTab={liveActiveTab}
                onTabChange={handleLiveTabChange}
                onProgramSelect={(programId) => setSelectedProgramId(programId)}
                refreshClicked={handleRefreshClick} // Pass function instead of boolean
              />
            </div>
            {/* <div className="live-session-bg"> */}
            {/* <img
              src={LiveBg}
              alt="No Live Bg"
              className="noLiveSessionBgImage"
            /> */}
            {/* </div> */}
            {/* Scrollable Cards */}
            {/* <div className="live-session-list">
    {sessions.length > 0 ? (
      sessions.map((card) => (
        <LiveSessionCard 
        key={card.event_id} 
        card={card} 
        handleonclick={() => registerApi(card.event_id, card.program_id)} 
        tabstatus={status}
        liveActiveTab={liveActiveTab}
        />
      ))
    ) : (
      // <p className="no-sessions">No sessions available</p>
     <div className="noLiveSession">
        <img
        src={noSession}
        alt="No session"
        className="noLiveSessionImage"
        />
      

      <div className="noLiveSessionText">
        {liveActiveTab === 0 && "You have no ongoing session for now"}
        {liveActiveTab === 1 && "You have no upcoming session for now"}
        {liveActiveTab === 2 && "You have no completed session for now"}
      </div>
      </div>   
    )}
  </div> */}

            {/* Image and message rendered outside live-session-list */}
            {sessions.length === 0 && (
              <div className="noLiveSession">
                <img
                  src={noSession}
                  alt="No session"
                  className="noLiveSessionImage"
                />
                <div className="noLiveSessionText">
                  {liveActiveTab === 0 && "You have no ongoing session for now"}
                  {liveActiveTab === 1 &&
                    "You have no upcoming session for now"}
                  {liveActiveTab === 2 &&
                    "You have no completed session for now"}
                </div>
              </div>
            )}

            {/* Session List */}
            <div className="live-session-list">
              {sessions.length > 0 &&
                sessions.map((card) => (
                  <LiveSessionCard
                    key={card.event_id}
                    card={card}
                    handleonclick={() =>
                      registerApi(card.event_id, card.program_id)
                    }
                    tabstatus={status}
                    liveActiveTab={liveActiveTab}
                  />
                ))}
            </div>

            {showNotification && (
              <SuccessSnackPopUp
                message={showNotification}
                onClose={handleCloseNotification}
              />
            )}
          </div>
        </div>
      </div>
      <div className="mobile-ui_assessmentCheck">
        <p>The Livesession is not accessible on mobile devices.</p>{" "}
      </div>
      <LiveSessionNeedHelp
        isOpen={isModalOpen}
        toggleModal={needHelptoggleModal}
      />
    </div>
  );
};

export default LiveSessionPageVersionTwo;
